export enum NewsCategory {
  General = 'GENERAL',
  Building_And_Construction = 'BUILDING_AND_CONSTRUCTION',
  Municipalities_And_Public = 'MUNICIPALITIES_AND_PUBLIC',
  Trade_And_Commodity = 'TRADE_AND_COMMODITY',
  Logistics_And_Warehousing = 'LOGISTICS_AND_WAREHOUSING',
  Mobility = 'MOBILITY',
  Education = 'EDUCATION',
  Professional_Services = 'PROFESSIONAL_SERVICES',
  Real_Estate = 'REAL_ESTATE', 
  Safety_And_Health = 'SAFETY_AND_HEALTH',
  Food_Packaging_And_Retail = 'FOOD_PACKAGING_AND_RETAIL',
  Housing_Associations = 'HOUSING_ASSOCIATIONS',
  Healthcare = 'HEALTHCARE'
}
